import { Container, Row, Col } from "reactstrap";

import {
    PlayArrow,
    YouTube
} from "@mui/icons-material";

import "./CAD_Course_Details.css";


function CADCourseDetails({
    featured,
    videos = [],
    title = "Complete Course Details",
    description = ""
}) {

    return (
        <section className="cad-course-details">

            <Container>

                {/* =====================================
                    SECTION HEADER
                ===================================== */}

                <Row className="justify-content-center">

                    <Col lg="9">

                        <div className="cad-details-header text-center">

                            <span className="cad-details-badge">

                                <span className="cad-details-badge-dot"></span>

                                COURSE DETAILS

                            </span>


                            <h2 className="cad-details-title">
                                {title}
                            </h2>


                            <div className="cad-details-divider">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>


                            {description && (

                                <p className="cad-details-description">
                                    {description}
                                </p>

                            )}

                        </div>

                    </Col>

                </Row>


                {/* =====================================
                    FEATURED VIDEO
                ===================================== */}

                {featured && (

                    <Row className="justify-content-center">

                        <Col lg="11" xl="10">

                            <div className="cad-featured-video-card">

                                <div className="cad-featured-video-content">

                                    <div className="cad-featured-video-label">

                                        <span>
                                            FEATURED SESSION
                                        </span>

                                        <YouTube />

                                    </div>


                                    {/* <h3>
                                        {featured.title}
                                    </h3> */}


                                    {/* {featured.description && (

                                        <p>
                                            {featured.description}
                                        </p>

                                    )} */}

                                </div>


                                <div className="cad-featured-video-frame">

                                    <iframe
                                        src={featured.videoUrl}
                                        title={featured.title}
                                        loading="lazy"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    />

                                </div>

                            </div>

                        </Col>

                    </Row>

                )}


                {/* =====================================
                    VIDEO GRID
                ===================================== */}

                {videos.length > 0 && (

                    <div className="cad-video-library">

                        <div className="cad-video-library-header">

                            <div>

                                <span>
                                    PRACTICAL TRAINING
                                </span>

                                <h3>
                                    Real Projects & Training Sessions
                                </h3>

                            </div>


                            <div className="cad-video-count">
                                {videos.length} Videos
                            </div>

                        </div>


                        <Row className="g-4">

                            {videos.map((video, index) => (

                                <Col
                                    lg="4"
                                    md="6"
                                    sm="12"
                                    key={`${video.title}-${index}`}
                                >

                                    <article className="cad-video-card">

                                        {/* Video */}

                                        <div className="cad-video-frame">

                                            <iframe
                                                src={video.videoUrl}
                                                title={video.title}
                                                loading="lazy"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            />

                                            <div className="cad-video-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                        </div>


                                        {/* Content */}

                                        <div className="cad-video-content">

                                            <div className="cad-video-label">
                                                {video.label}
                                            </div>


                                            <h4>
                                                {video.title}
                                            </h4>


                                            <div className="cad-video-watch">

                                                <span className="cad-video-play">
                                                    <PlayArrow />
                                                </span>

                                                <span>
                                                    Watch Project
                                                </span>

                                            </div>

                                        </div>

                                    </article>

                                </Col>

                            ))}

                        </Row>

                    </div>

                )}

            </Container>

        </section>
    );
}


export default CADCourseDetails;